<div class='tab-with-scroll'>
  <div *ngIf='showTabArrow'
       class='tab-arrow-left'>
    <pt-icon (click)='scroolTab(tabContent, - STEP)'
             [key]='IconArrowLeft'
             class='cursor-pointer'
    ></pt-icon>
  </div>

  <div [ngClass]="{
    'tab-link--no-scrool': !showTabArrow,
    'nav-multiline': activeSmallView
    }"
       class='tab-link'>
    <ul #tabContent
        class='nav nav-tabs nav-scrollable'>
      <li *ngFor='let tab of groups'
          class='nav-item'
          container='body'
          [ngClass]="{'active': selectedGroup?.id === tab.id}"
          ngbTooltip='{{disabledChangeGroup && selectedGroup?.id !== tab.id ?
               ("MESSAGE.BEFORE_CONTINUED_SAVE" | translate) : null}}'>
        <a (click)='changeTab(tab)'
           [ngClass]="{
           'active': selectedGroup?.id === tab.id,
           'disabled': disabledChangeGroup && selectedGroup?.id !== tab.id
           }"
           class='nav-link'
           style='width: inherit;'>
          {{ tab.name }}
          <pt-w-help (click)="$event.stopPropagation()" [help]='tab.help'></pt-w-help>
        </a>
      </li>
    </ul>
  </div>
  <div class="end-tab"></div>

  <div *ngIf='showTabArrow'
       class='tab-arrow-right'>
    <pt-icon (click)='scroolTab(tabContent, STEP)'
             [key]='IconArrowRight'
             class='cursor-pointer'
    ></pt-icon>
  </div>
</div>
